module.exports = __webpack_public_path__ + "static/media/green-white-leaf.fb8fa810.jpg";